import { ReactNode } from 'react';

export interface SidebarProps {
    title: string;
    /** Sidebar width (px number or CSS string). Defaults to the stylesheet width. */
    width?: number | string;
    children?: ReactNode;
}

/**
 * Left column content for StandardModal: logo, title, then any children (e.g. navigation or a step list).
 */
export const Sidebar = ({ title, width, children }: SidebarProps) => {
    return (
        <div
            className='standardModalSidebar'
            style={width !== undefined ? { flexBasis: width } : undefined}
        >
            <img
                className='standardModalSidebar-logo'
                src='/images/header-logo.png'
                alt='Builder Finance'
            />
            {title && <h2 className='standardModalSidebar-title'>{title}</h2>}
            {children && <div className='standardModalSidebar-body'>{children}</div>}
        </div>
    );
};
